export default __webpack_public_path__ + "static/media/settings.5eeb347b.svg";